export function TypingIndicator() {
    return (
        <div className="flex flex-col items-start px-3 py-2">
            <div className="flex justify-start">
                <div className="mr-2 flex max-h-[40px] w-[40px] flex-shrink-0 items-center justify-center rounded-full bg-[#101210] p-1">
                    <img src="/images/sgLogo.svg" alt="Studio Graphene Logo" width={32} height={32} className="mb-[2px] ml-[6px]" />
                </div>
                <div className="rounded-tl-[2px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] border border-gray-200 bg-white px-4 py-3 text-gray-900 shadow-sm">
                    <div className="flex space-x-1 items-center h-4">
                        <span className="text-xs font-medium text-gray-500 mr-1">Thinking</span>
                        <div className="flex space-x-1">
                            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
